import Util from '../Util';

class LoginAttempt {
  constructor(obj = {}) {
    this.email = obj.email;
    this.firstName = obj.firstName;
    this.lastName = obj.lastName;
    this.externalIP = obj.externalIP;
    this.userAgent = obj.userAgent;
    this.isSuccess = obj.isSuccess;
    this.dateCreated = obj.dateCreated;

    // extra
    this.dateCreatedDateTime = Util.localDateTimeString(obj.dateCreated);
    this.dateCreatedXAgo = 'unknown';
    if (obj.dateCreated) {
      this.dateCreatedXAgo = Util.xUnitsOfTimeAgo(obj.dateCreated);
    }
  }

  toPlainObject() {
    let obj = {};
    let keys = Object.keys(this);
    for (let k of keys) {
      switch (k) {
        // don't include these keys
        case 'dateCreatedDateTime':
        case 'dateCreatedXAgo':
          break;
        default:
          obj[k] = this[k];
      }
    }
    return obj;
  }
}

export default LoginAttempt;



// WEBPACK FOOTER //
// ./src/model/LoginAttempt.js